export default "__VITE_ASSET__JZq_WDO6__"